export const envVariables = {
	appConfigVersion: process.env.REACT_APP_CONFIG_VERSION || 'local',
	clearStorageOnLogin: process.env.REACT_APP_CLEAR_STORAGE_ON_LOGIN === 'true',
	baseUrl: process.env.REACT_APP_API_BASE_URL || '',
	clientName: process.env.REACT_APP_CLIENT_NAME || 'Client',
	clientLogo: process.env.REACT_APP_CLIENT_LOGO || '',
	googleAnalyticsId: process.env.REACT_APP_GOOGLE_ANALYTICS_ID || '',
	tableauServerBaseUrl: process.env.REACT_APP_TABLEAU_SERVER_BASE_URL || '',
	tableauSite: process.env.REACT_APP_TABLEAU_SITE || '',
	tableauTrustUrl: process.env.REACT_APP_TABLEAU_TRUST_URL || '',
	tableauTabsPermission: Number(process.env.REACT_APP_TABLEAU_TABS_PERMISSION || 2),
	tableauDashboardProject: process.env.REACT_APP_TABLEAU_DASHBOARD_PROJECT || '',
	tableauDashboardPage: process.env.REACT_APP_TABLEAU_DASHBOARD_PAGE || '',
	tableauProductProject: process.env.REACT_APP_TABLEAU_PRODUCT_PROJECT || '',
	tableauProductPage: process.env.REACT_APP_TABLEAU_PRODUCT_PAGE || '',
	tableauViews: {
		evaluacion: process.env.REACT_APP_TABLEAU_VIEW_EVALUACION || '',
		historial: process.env.REACT_APP_TABLEAU_VIEW_HISTORIAL || '',
		planificacion: process.env.REACT_APP_TABLEAU_VIEW_PLANIFICACION || '',
		panelmargenes: process.env.REACT_APP_TABLEAU_VIEW_PANEL_MARGENES || '',
		vistaproducto: process.env.REACT_APP_TABLEAU_VIEW_VISTA_PRODUCTO || '',
		panelpenetraciones: process.env.REACT_APP_TABLEAU_VIEW_PANEL_PENETRACIONES || '',
		forecastprecios: process.env.REACT_APP_TABLEAU_VIEW_FORECAST_PRECIOS || '',
		preciosporsala: process.env.REACT_APP_TABLEAU_VIEW_PRECIOS_POR_SALA || '',
		default: process.env.REACT_APP_TABLEAU_VIEW_DEFAULT || '',
	},
}
